import React from 'react';
import { organizationOptionLabel } from '../utils/inviteRegistration';

export function OrganizationSelectFields({
  organizations = [],
  selectedOrgId,
  onChange,
  onBack,
  inviteOrgHint,
}) {
  return (
    <div>
      <label htmlFor="organization" className="block text-sm font-medium text-gray-700 mb-1">
        Organization
      </label>
      <select
        id="organization"
        name="organization"
        required
        value={selectedOrgId}
        onChange={onChange}
        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
      >
        <option value="">Select organization...</option>
        {organizations.map((org) => (
          <option key={org.id} value={org.id}>
            {organizationOptionLabel(org)}
            {inviteOrgHint?.id && String(inviteOrgHint.id) === String(org.id) ? ' — recommended' : ''}
          </option>
        ))}
      </select>
      {inviteOrgHint?.name && (
        <p className="mt-1 text-xs text-gray-500">
          For this invitation, choose <strong>{inviteOrgHint.name}</strong>
          {inviteOrgHint.role ? <> as <strong>{inviteOrgHint.role}</strong></> : null}.
        </p>
      )}
      <button
        type="button"
        onClick={onBack}
        className="mt-2 text-sm text-blue-600 hover:text-blue-500"
      >
        Use a different account
      </button>
    </div>
  );
}
